// latest: zhangmyh 2017-3-21 10:06 AM
/* global $ u */

let _config
function init (refer) {
  let vm = {
    model: _config.model
  }
  let app = u.createApp()
  app.init(vm, $('#refer_scheme_save')[0])
  refer.registerSubmitFunc(() => {
    return true
  })
  _config.submit = refer.submit.bind(refer)
}

let template = require('./index.html')
export default function (config) {
  _config = config
  return {
    init,
    template
  }
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/evaluationScheme/save/index.js